// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// ...

declare global {
  interface Window {
    __wxjs_environment: 'miniprogram' | 'browser'
  }
}

const env = {
  isMeijiabang(): boolean {
    return /meijiabang/i.test(window.navigator.userAgent)
  },

  isIOS(): boolean {
    return /(iphone|ipod|ipad).*applewebkit(?!.*safari)/i.test(window.navigator.userAgent)
  },
  isAndroid(): boolean {
    return /android/i.test(window.navigator.userAgent)
  },

  isWeChat(): boolean {
    return /MicroMessenger\/([\d.]+)/i.test(window.navigator.userAgent)
  },

  isMiniProgram(): boolean {
    return env.isWeChat() && window.__wxjs_environment === 'miniprogram'
  },

  isQQ(): boolean {
    return / QQ/.test(window.navigator.userAgent)
  },

  isWeibo(): boolean {
    return /Weibo/i.test(window.navigator.userAgent)
  },

  isIPhoneX(): boolean {
    return env.isIOS() && (screen.height === 812 && screen.width === 375)
  },

  supportFetch(): boolean {
    return 'fetch' in window
  },

  supportSessionStorage(): boolean {
    return !!(
      window.sessionStorage &&
      Object.prototype.toString.call(window.sessionStorage).indexOf('Storage') === 8
    )
  },

  supportLocalStorage(): boolean {
    return !!(
      window.localStorage &&
      Object.prototype.toString.call(window.localStorage).indexOf('Storage') === 8
    )
  },

  supportPromise(): boolean {
    return 'Promise' in window && Promise.toString().indexOf('[native code]') !== -1
  },

  supportServiceWorker(): boolean {
    return 'serviceWorker' in navigator
  },

  supportWebWorker(): boolean {
    return 'Worker' in window
  },

  supportWebGL(): boolean {
    const canvas = document.createElement('canvas')

    return (
      'WebGLRenderingContext' in window &&
      !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    )
  },

  supportWebp(): boolean {
    const canvas = document.createElement('canvas')
    const data = canvas.toDataURL('image/webp') || 'data'

    return !!(data && data.indexOf('data:image/webp') === 0)
  },

  supportPerformance(): boolean {
    return 'performance' in window
  },

  supportVue(): boolean {
    return 'Vue' in window
  }
}

export default env
export { env }
